import React, { FC, SVGProps } from 'react'

import { Box, SxProps, Theme } from '@mui/material'

import ButtonWithIconComponent from 'components/ButtonWithIcon'

import editIcon from 'assets/images/editIcon.svg'
import refreshIcon from 'assets/images/refreshIcon.svg'

import { styles } from './FacilitationHeader.styles'

export const TEST_ID = 'facilitation-header'

export interface FacilitationHeaderProps {
	editIconElement?: JSX.Element
	editIconSvg?: string | FC<SVGProps<SVGElement>>
	editTestId?: string
	isLoading?: boolean
	onEdit?: () => void
	onRefresh?: () => void
	refreshIconElement?: JSX.Element
	refreshIconSvg?: string | FC<SVGProps<SVGElement>>
	refreshTestId?: string
	sx?: SxProps<Theme>
}

const FacilitationHeader: React.FC<FacilitationHeaderProps> = ({
	onRefresh,
	onEdit,
	isLoading = false,
	refreshTestId,
	editTestId,
	sx,
	refreshIconSvg = refreshIcon,
	editIconSvg = editIcon,
	refreshIconElement,
	editIconElement,
}) => {
	const mergedSx = [
		styles.container,
		...(sx ? [sx] : []),
	] as unknown as SxProps<Theme>

	return (
		<Box role="group" aria-label="facilitation-actions" sx={mergedSx}>
			{onRefresh && (
				<ButtonWithIconComponent
					sx={styles.button}
					disabled={isLoading}
					Icon={refreshIconElement}
					iconSvg={!refreshIconElement ? refreshIconSvg : undefined}
					text="REFRESH"
					data-testid={refreshTestId}
					onClickAction={onRefresh}
				/>
			)}
			{onEdit && (
				<ButtonWithIconComponent
					sx={styles.button}
					disabled={isLoading}
					Icon={editIconElement}
					iconSvg={!editIconElement ? editIconSvg : undefined}
					text="EDIT"
					data-testid={editTestId}
					onClickAction={onEdit}
				/>
			)}
		</Box>
	)
}

export default FacilitationHeader
